import styled from "styled-components"

export const Holder = styled.div`
  width: 90vw;
  height: 100%;
  user-select: none;
  pointer-events: none;
  position: relative;
`
export const Pivot = styled.div`
  position: absolute;
  top: 43%;
  left: 38%;
  width: 65%;
  transform: translate(-50%, -50%);
  z-index: 2;
`
export const PicHolder = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`
export const Pic = styled.img`
  width: 100%;
`
export const Overlay = styled.div`
  position: absolute;
  top: 50%;
  right: 0;
  transform: translate(50%, -50%);
  z-index: -1;
`
export const Caption = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  background-color: white;
  padding: 2vw 2vw 2vw 54%;
  position: relative;
  width: 42vw;
  height: 100%;
  background-color: #e1eae9;
`
export const QuoteText = styled.p`
  font-family: NewParisKingSize-Regular;
  font-style: normal;
  font-size: 1.2vw;
  line-height: 120%;
  letter-spacing: 0.1em;
  color: #bf6260;
  text-align: center;
`
export const Text = styled.p`
  font-family: AzoSans-Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 0.87vw;
  line-height: 150%;
  color: #0a243c;
  padding: 0;
  margin: 1em 0;
`
export const TopQ = styled.img`
  width: 2vw;
`
export const BottomQ = styled.img`
  width: 1.6vw;
  margin: 1.7vw 0;
`
export const TitleHolder = styled.div`
  position: absolute;
  z-index: 1;
  left: 0;
  bottom: -2vw;
  transform: translateY(100%);
`
export const Title = styled.p`
  font-family: NewParisKingSize-Regular;
  font-style: normal;
  font-size: 3.5vw;
  letter-spacing: 0.1em;
  color: #75938f;
  margin: 0;
  padding: 0;
`
export const SubTitle = styled.p`
  font-family: OuterSans-Regular;
  font-style: normal;
  font-size: 0.9vw;
  letter-spacing: 0.1em;
  color: #000000;
  margin: 0;
  padding: 0;
  text-indent: 0.5em;
`
